import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
  Chip,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDataProvider } from 'react-admin';
import { getChainId } from '../../../../lib';
import { AsyncAutocomplete } from '../../../../components';

interface Place {
  id: string;
  name: string;
  integration?: string | null;
}

interface PlaceSelectionModalProps {
  open: boolean;
  onClose: () => void;
  onSelect: (place: Place) => void;
  alreadySelected: string[];
}

const PlaceSelectionModal: React.FC<PlaceSelectionModalProps> = ({
  open,
  onClose,
  onSelect,
  alreadySelected,
}) => {
  const [selectedPlace, setSelectedPlace] = useState<Place | null>(null);
  const [chainId] = useState(getChainId());

  const handleAdd = () => {
    if (selectedPlace) {
      onSelect(selectedPlace);
      setSelectedPlace(null);
      onClose();
    }
  };

  const handleClose = () => {
    setSelectedPlace(null);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          Adicionar Locais de Resgate
          <IconButton onClick={handleClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box py={1}>
          <AsyncAutocomplete
            resource={`chains/${chainId}/places`}
            label="Selecione o local"
            value={selectedPlace}
            onChange={(newValue) => setSelectedPlace(newValue)}
            getOptionLabel={(option: any) => option.name || ''}
            getOptionDisabled={(option: any) => alreadySelected.includes(option.id)}
            renderOption={(props, option: any) => (
              <li {...props} key={option.id}>
                <Box display="flex" alignItems="center" gap={1} width="100%">
                  <span>{option.name}</span>
                  {alreadySelected.includes(option.id) && (
                    <Chip
                      label="Já adicionado"
                      size="small"
                      color="default"
                      sx={{ ml: 'auto' }}
                    />
                  )}
                </Box>
              </li>
            )}
            helperText="Selecione um local onde o brinde pode ser resgatado"
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} color="inherit">
          Cancelar
        </Button>
        <Button
          onClick={handleAdd}
          variant="contained"
          disabled={!selectedPlace}
        >
          Adicionar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PlaceSelectionModal;
